import * as React from "react";

import LinearProgress from "@mui/material/LinearProgress";

export default function Loader() {
  return (
    <LinearProgress
      color="primary"
      sx={{
        zIndex: 1000000,
      }}
    />
  );
}
